// extracted by mini-css-extract-plugin
export default {"timeAnswerBlock":"TimeAnswer_timeAnswerBlock__oWuTR","buttonWrap":"TimeAnswer_buttonWrap__QnAfo","button":"TimeAnswer_button__gOkOb","inputNum":"TimeAnswer_inputNum__D1ghz"};